import { render } from "./TraineeProjectModal.vue?vue&type=template&id=3dad15fe&scoped=true"
import script from "./TraineeProjectModal.vue?vue&type=script&lang=js"
export * from "./TraineeProjectModal.vue?vue&type=script&lang=js"

import "./TraineeProjectModal.vue?vue&type=style&index=0&id=3dad15fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dad15fe"]])

export default __exports__